/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { DETAILS: de },
  'el-GR': { DETAILS: el },
  'en-US': { DETAILS: en },
  'es-ES': { DETAILS: es },
  'fi-FI': { DETAILS: fi },
  'fr-FR': { DETAILS: fr },
  'it-IT': { DETAILS: it },
  'pl-PL': { DETAILS: pl },
  'pt-PT': { DETAILS: pt }
};
